import React from "react";
import { Link as ScrollLink } from "react-scroll";

const aboutData = {
  cvpath: "media/empty.pdf",
  image: "images/about.png",
  name: "Wing Lam",
  bachelor: "University of California, Los Angeles (UCLA)",
  master: "Georgia Institute of Technology",
  major2: "MS in Computer Science",
  email: "misslamwing@gmail.com",
  aboutMe:
    "I am Wing Lam. I am an experienced Software Engineer seeking to use my skills and knowledge to design and develop high-quality, efficient, and reliable software systems for a dynamic and innovative organization. My goal is to continuously learn and stay up-to-date with the latest technologies and industry trends to help drive the success of the company.",
};



function About() {
  return (
    <div className="row">
      <div className="col-md-3">
        <img src={aboutData.image} alt={aboutData.name} />
      </div>
      <div className="col-md-9">
        <h2 className="mt-4 mt-md-0 mb-4">Hello World!</h2>
        <p className="mb-0">{aboutData.aboutMe}</p>
        <div className="row my-4">
          <div className="col-md-6">
            
            <p className="mb-2">
              Bachelor: <span className="text-dark">{aboutData.bachelor}</span>
            </p>
            <p className="mb-2">
              Master: <span className="text-dark">{aboutData.master}</span>
            </p>
            <p className="mb-2">
              Major: <span className="text-dark">{aboutData.major2}</span>
            </p>
          </div>
          {/*<div className="col-md-6 mt-2 mt-md-0 mt-sm-2">*/}

          {/*  */}
          {/*</div>*/}
        </div>
        {/* <a href={aboutData.cvpath} className="btn btn-default mr-3">
          <i className="icon-cloud-download"></i>Download CV
        </a> */}
        <ScrollLink
          activeClass="active"
          to="section-contact"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-alt mt-2 mt-md-0 mt-xs-2"
        >
          <i className="icon-envelope"></i>Contact Me
        </ScrollLink>
      </div>
    </div>
  );
}

export default About;
